<template lang="pug">
  .day
      .date {{ day.date | moment('dd. Do MMM ')}}
      .events
        .event(v-for="event in day.events")
          dl
            dt {{ event.badge }}
            dd {{ event.start | moment('HH:mm') }} - {{ event.name }}

      span.bold PAX:
      span  {{ day.pax}}
      span.bold(v-if="day.sold_out")  ausverkauft!

      div
        span.bold Ende VA ca.:
        span(v-if="day.planned_end")  {{ day.planned_end.split(':').slice(0, 2).join(':') }} Uhr
        span(v-else)  -

      .production-managers(v-if="day.production_managers.length > 0")
        span.bold PL: &nbsp;
        span.manager(v-for="manager in day.production_managers") {{ manager }}
      .day-managers(v-if="day.day_managers.length > 0")
        span.bold TL: &nbsp;
        span.manager(v-for="manager in day.day_managers") {{ manager }}
      .managers(v-if="day.managers.length > 0")
        span.bold AL: &nbsp;
        span.manager(v-for="manager in day.managers") {{ manager }}

      // day schedule
      .schedule(v-if="day.schedule && day.schedule !== ''")
        h3 Tagesablauf
        p(v-html="$options.filters.linebreaks(day.schedule)")

      // dokumente
      .documents(v-if="day.documents.length > 0")
        h3 Dokumente
        ul.files
          li(v-for="doc in day.documents")
            a(:href="doc.url", target="_blank")
              i.fa(:class="doc.icon")
              |  {{ doc.name }}

      shift(v-for="(shift, index) in day.shifts", :shift="shift",
        :key="shift.id", :class="{'gray': index % 2 === 0}")

</template>

<script>
export default {
  name: 'PlannedDay',
  props: ['day'],
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  }
}
</script>


<style lang="sass">

.schedule
  margin-top: 0.5em
  padding: 15px
  font-weight: normal
  background: #f4f4f4
  border: 1px solid cornflowerblue
  h3
    font-weight: bold

.day
  text-align: left
  margin: 1.5em 0
  padding: 10px
  background: rgba(44, 44, 44, 0.06)
  &.gray
    background: rgba(44, 44, 44, 0.15)

.date
  font-weight: bold
  font-size: 23px

dt, dd
  display: inline-block
  font-weight: bold
dt
  width: 80px

.day.is-today
  border-left: 6px solid #ce0400
  padding-left: 10px

.day.is-today:before
  content: 'HEUTE '
  color: #ce0400
  font-weight: bold
  font-size: 23px

.manager + .manager:before
  content: ', '

.bold
  font-weight: bold

.files i
  width: 20px

.documents
  margin-top: 0.5em
  margin-bottom: 2em
</style>



// WEBPACK FOOTER //
// PlannedDay.vue?e7cd8c68